/**
 * Page configuration 2FA
 * Wrapper autour du composant TwoFactorSettings du module auth
 */

import { useNavigate } from 'react-router-dom';
import { useAuth, TwoFactorSettings } from '@features/auth';
import { APP_NAME } from '../../shared/utils/appConfig';

export function TwoFactorSettingsPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="flex justify-center">
      <TwoFactorSettings
        userId={user.id}
        currentMethod={user.deuxFacteursMethode}
        is2FAEnabled={user.deuxFacteursActive}
        appName={APP_NAME}
        onBack={() => navigate('/dashboard')}
      />
    </div>
  );
}
